import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["value"];
import { ref, watch, computed, useId } from 'vue';
import { setError, removeError } from '@ts/components/form/utils';
import { ___ } from '@ts/common/language';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PureTime',
    props: /*@__PURE__*/ _mergeModels({
        errorId: { default: () => useId() },
        hasSeconds: { type: Boolean },
        notNull: { type: Boolean }
    }, {
        "value": { required: true },
        "valueModifiers": {},
        "errors": { required: false, default: () => ({}) },
        "errorsModifiers": {},
    }),
    emits: ["update:value", "update:errors"],
    setup(__props) {
        const props = __props;
        const value = _useModel(__props, 'value');
        const errors = _useModel(__props, 'errors');
        const displayValue = ref(formatDisplay(value.value));
        const inputRegex = computed(() => {
            return props.hasSeconds
                ? /^\d*(:\d{0,2}(:\d{0,2})?)?$/
                : /^\d*(:\d{0,2})?$/;
        });
        watch(() => value.value, (newVal) => {
            const currentParsed = parseToSeconds(displayValue.value);
            if (currentParsed !== newVal) {
                if (newVal !== null) {
                    clearFormatError();
                }
                displayValue.value = formatDisplay(newVal);
            }
        });
        function clearFormatError() {
            removeError(errors, props.errorId, 'format');
        }
        function clearNotNullError() {
            removeError(errors, props.errorId, 'not-null');
        }
        function setFormatError() {
            setError(errors, props.errorId, 'format', ___({ en: 'Invalid time format.', de: 'Ungültiges Zeitformat.' }));
        }
        function setNotNullError() {
            setError(errors, props.errorId, 'not-null', ___({ en: 'Input cannot be empty.', de: 'Eingabe darf nicht leer sein.' }));
        }
        function parseToSeconds(val) {
            if (val === "") {
                clearFormatError();
                if (props.notNull === true) {
                    setNotNullError();
                }
                return null;
            }
            else {
                clearNotNullError();
            }
            if (val.endsWith(':')) {
                setFormatError();
                return null;
            }
            else {
                clearFormatError();
            }
            const parts = val.split(':').map(p => p === '' ? 0 : Number(p));
            if (parts.some(p => isNaN(p)))
                return null;
            let h = 0, m = 0, s = 0;
            if (parts.length === 1) {
                h = parts[0];
            }
            else if (parts.length === 2) {
                [h, m] = parts;
            }
            else if (parts.length === 3) {
                if (!props.hasSeconds)
                    return null; // Should be blocked by regex, but safety check
                [h, m, s] = parts;
            }
            if (m >= 60 || s >= 60) {
                setFormatError();
                return null;
            }
            else {
                clearFormatError();
            }
            return (h * 3600) + (m * 60) + s;
        }
        function formatDisplay(val) {
            if (val === null)
                return "";
            const h = Math.floor(val / 3600);
            const m = Math.floor((val % 3600) / 60);
            const s = val % 60;
            const pad = (n) => n.toString().padStart(2, '0');
            const hStr = pad(h);
            const mStr = pad(m);
            const sStr = pad(s);
            if (props.hasSeconds) {
                return `${hStr}:${mStr}:${sStr}`;
            }
            return `${hStr}:${mStr}`;
        }
        function blockInvalidChar(e) {
            if (e.ctrlKey || e.metaKey || e.key.length > 1)
                return;
            const target = e.target;
            const start = target.selectionStart ?? 0;
            const end = target.selectionEnd ?? 0;
            const newValue = target.value.slice(0, start) + e.key + target.value.slice(end);
            if (!inputRegex.value.test(newValue)) {
                e.preventDefault();
            }
        }
        function handleInput(e) {
            const target = e.target;
            const val = target.value;
            if (!inputRegex.value.test(val)) {
                target.value = displayValue.value;
                return;
            }
            displayValue.value = val;
            value.value = parseToSeconds(val);
        }
        function onBlur() {
            const currentSeconds = parseToSeconds(displayValue.value);
            if (currentSeconds === null) {
                if (value.value !== null)
                    value.value = null;
                return;
            }
            const canonical = formatDisplay(currentSeconds);
            if (displayValue.value !== canonical) {
                displayValue.value = canonical;
            }
            if (value.value !== currentSeconds) {
                value.value = currentSeconds;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("input", {
                type: "text",
                placeholder: "hh:mm",
                value: displayValue.value,
                onKeydown: [
                    blockInvalidChar,
                    _cache[0] || (_cache[0] = _withKeys(_withModifiers(() => { }, ["prevent"]), ["enter"]))
                ],
                onInput: handleInput,
                onBlur: onBlur
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1));
        };
    }
});
